import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { DeleteMeetingPopupComponent } from '../delete-meeting-popup/delete-meeting-popup.component';
import { Globals } from 'src/app/service/global';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-not-held-popup',
  templateUrl: './not-held-popup.component.html',
  styleUrls: ['./not-held-popup.component.css'],
  providers: [DatePipe]
})
export class NotHeldPopupComponent implements OnInit {

  meetingId: any;
  reason:any
  meetingResponse:any
  private readonly notifier!: NotifierService;

  constructor( public datepipe: DatePipe,private globals: Globals,notifierService: NotifierService,private sideNav : SideNavServiceService,private meetingService: MeetingService,private _mdr: MatDialogRef<DeleteMeetingPopupComponent>,@Inject(MAT_DIALOG_DATA) data: any) { 
    this.notifier = notifierService;
    //this.meetingResponse = data.meetingId;
    ///this.meetingId = data.meetingId.meetingId;
    this.meetingResponse = data['meeting'];
    this.meetingId = data['meeting'].meetingId;
    this.reason = data['meeting'].notHeldReason;
    
    
  }

  ngOnInit(): void {
  }
  
  notHeldMeeting(){
    var date = new Date(this.meetingResponse.meetingDateStr);
    var meetingDate = this.datepipe.transform(date, "MMM dd, YYYY");
    var notHeldMeetingJson = {
      "notHeldReason":this.reason,
      "meetingStartTime":this.meetingResponse.meetingStartTime,
      "meetingTitle": this.meetingResponse.meetingTitle,
      "meetingDateStr":meetingDate,
      "orgCode": this.globals.orgCode,
      "userId": this.globals.userId,
      "visitorTimeZone":this.globals.vTimeZone
    };
 

    if(this.reason != null && this.reason != undefined && this.reason!="null" && this.reason != ""){

      this.meetingService.updateMeeting(this.meetingResponse.meetingId, notHeldMeetingJson).subscribe(responsedata => {
        this.sideNav.alertMeetingReason('Data Saved Successfully','success');     
      });
    }else{
      this.sideNav.alertMeetingReason('Enter Reason!','error');
    }
    this.closeDialog();
  }
  closeDialog() {
    this._mdr.close(false)
  }

}
